/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An entry in Speakeasy's curated CIMD preset catalog.
 */
export type CimdClientPreset = {
  /**
   * The https URL this client presents as its client_id. Usually exact; when is_pattern is true this is a wildcard pattern rather than a literal URL.
   */
  clientIdMetadataUri: string;
  /**
   * Human-readable client name.
   */
  displayName: string;
  /**
   * Whether presets-mode issuers currently admit this entry. Disabled entries are listed so operators can see that Speakeasy knows about the vendor.
   */
  enabled: boolean;
  /**
   * True when client_id_metadata_uri contains a `*` wildcard, matching a whole namespace of client_ids rather than one URL. Used for vendors that mint a separate metadata document per connector or install, so their client_ids cannot be enumerated. A `*` stands for exactly one path segment and never widens the host.
   */
  isPattern: boolean;
  /**
   * Stable identifier for the publishing vendor. Not unique — a vendor may publish several client documents.
   */
  vendorKey: string;
};

/** @internal */
export const CimdClientPreset$inboundSchema: z.ZodMiniType<
  CimdClientPreset,
  unknown
> = z.pipe(
  z.object({
    client_id_metadata_uri: z.string(),
    display_name: z.string(),
    enabled: z.boolean(),
    is_pattern: z.boolean(),
    vendor_key: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_id_metadata_uri": "clientIdMetadataUri",
      "display_name": "displayName",
      "is_pattern": "isPattern",
      "vendor_key": "vendorKey",
    });
  }),
);

export function cimdClientPresetFromJSON(
  jsonString: string,
): SafeParseResult<CimdClientPreset, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CimdClientPreset$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CimdClientPreset' from JSON`,
  );
}
